
function Tours() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/city-img/tour_banner.JPG" alt="Stadt von oben" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Touren in und um Wismar</h1>
                            <p>Viel zu entdecken gibt es nicht nur im Apartment 5 sondern auch drumherum. Als Stadttour, 
                                Fahrradausflug oder Restauranttour - im kleinen Wismar erwarten dich große Erlebnisse.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Sightseeing Tour</h2>
                            <p>Ob als geführter Stadtrundgang, in Eigenregie oder ganz bequem als Stadtrundfahrt - Wismar 
                                und ihre Bauwerke lassen sich auf vielfältige Art und Weise erkunden und entdecken.<br></br> 
                                Neben der klassischen öffentlichen Stadtführung gibt es auch die Nachtwächterführung, bei 
                                der sich die Hansestadt in abendlicher Stimmung präsentiert. Wer es themenbezogen mag, probiert 
                                am besten die SOKO-Wismar-Stadtführung aus, angelehnt an Dreh- und Tatorte der beliebten 
                                Krimiserie, oder die Nosferatu-Tour, die sich auf die Spuren des Gruselfilmklassikers begiebt. 
                                <br></br>Für Rundfahrten gibt es auch in Wismar den Cabrio-Doppeldecker Bus, der luftiges 
                                Sightseeing-Vergnügen ohne müde Füße möglich macht. Die etwas andere nostalgische Rundfahrt 
                                erlebt man im amerikanischen gelben Schulbus, der sich auch durch die kleinsten Nebenstraßen 
                                schlängelt. Für alle, die sich beim Schauen von US Movies schon immer mal gefragt haben, wie 
                                sich eine Fahrt darin wohl anfühlt.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Radtouren</h2>
                            <p>Die wohl schönste Art das Wismarer Umland zu entdecken. Entweder auf den eigens mitgebrachten 
                                Drahteseln oder auf Leihrädern aus der Wismarer Innenstadt. In die Pedale tretend sich die 
                                norddeutsche Brise um die Nase wehen lassen und dabei den Blick über die atemberaubenden Weiten 
                                der mecklenburgischen Landschaft schweifen lassen.<br></br>Auch hier bieten sich thematisch die 
                                verschiedensten Touren an, entlang der Wismarer Bucht, im Wismarer Norden und Westen oder etwas 
                                weiter außerhalb Schlösser und Burgen radelnd entdecken. Nicht zu vergessen die Insel Poel, die 
                                sich nicht nur für Strandausflüge bestens eignet.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Bootstouren</h2>
                            <p>Was bietet sich an der Ostsee besser an als eine Tour auf dem Wasser? Ganz klassisch als Hafenrundfahrt, 
                                um Wismar von der Seeseite aus zu erkunden, oder um zur Halbinsel Poel zu schippern und dort einen 
                                der angesagten Strandtage zu verbringen. Für das historische Feeling heuert man am besten auf der 
                                Poeler Kogge an, dem urischen Nachbau aus dem Mittelalter.<br></br>Wer es aktiver mag, nimmt das 
                                Tretboot oder bucht eine Speedboottour zu den Kegelrobben auf der Seehundbank.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default Tours;